module.exports = __webpack_public_path__ + "img/矩形 593@2x.fb72c114.png";